// extracted by mini-css-extract-plugin
export var loginForm = "styles-module--loginForm--37qhp";
export var textError = "styles-module--textError--3eWKW";
export var link = "styles-module--link--r-0TZ";
export var formHeader = "styles-module--formHeader--2Z-jY";
export var formHeaderATExtra = "styles-module--formHeaderATExtra--1sMXS";
export var loginButtonWrapper = "styles-module--loginButtonWrapper--3WRvP";